var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{class:{
    'archive-header': true,
    'archive-header--node': _vm.isPrimaryNode,
    'archive-header--item': _vm.isItem || _vm.staticPage,
  }},[_c('div',{staticClass:"archive-header__text"},[_c('h2',{staticClass:"archive-header__title"},[_vm._v("Calculating Control")]),_c('div',{staticClass:"archive-header__meta"},[_vm._t("meta")],2)]),_c('div',{staticClass:"archive-header__center"},[_vm._t("default")],2),_c('nav',{staticClass:"archive-header__home"},[_c('div',{staticClass:"archive-header__lang blob blob--shadow",class:{
        'blob--pink': !_vm.isItem && _vm.isPrimaryNode && !_vm.staticPage,
        'blob--green': !_vm.isItem && !_vm.isPrimaryNode && !_vm.staticPage,
      }},[_c('LanguageSwitch',{staticClass:"archive-header__lang-switch"})],1),_c('HomeButton',{class:{
        'blob--pink': !_vm.isItem && _vm.isPrimaryNode && !_vm.staticPage,
        'blob--green': !_vm.isItem && !_vm.isPrimaryNode && !_vm.staticPage,
      },attrs:{"aria-label":"Home"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }